import { render, staticRenderFns } from "./NewsPost.vue?vue&type=template&id=157097fc&scoped=true&"
import script from "./NewsPost.vue?vue&type=script&lang=js&"
export * from "./NewsPost.vue?vue&type=script&lang=js&"
import style0 from "./NewsPost.vue?vue&type=style&index=0&id=157097fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157097fc",
  null
  
)

export default component.exports